module.exports = __webpack_public_path__ + "static/media/01.88ef28bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/01.jpg
// module id = 262
// module chunks = 0